import { Id } from 'src/types'
import { TicketChecked } from '.'

export default function sanitizeToPost(
  request_id: Id,
  tickets: TicketChecked[]
) {
  return tickets.reduce((acc, cur) => {
    cur.request_id = request_id
    delete cur.checked
    if (cur.request_violated_justification?.request_justification_id) {
      cur.request_violated_justification.request_id = request_id
    }
    return [...acc, cur]
  }, [] as TicketChecked[])
}
